import * as React from "react";
import { composeDataMethods } from "@lululemon/mwa-utils";

// for more on Server Side Effects (SSE) Please see this article:
// http://medium.com/@A__G__B/component-level-data-fetching-in-next-js-with-srr-8d35cdc5849e
export const getOrCreateSSEContext = () => {
  var _window$__NEXT_DATA__, _window$__NEXT_DATA__2, _window$__NEXT_DATA__3;
  if (typeof window === "undefined") {
    return require("use-sse").createServerContext();
  }
  const SSEContext = require("use-sse").createBroswerContext;
  window._initialDataContext = (_window$__NEXT_DATA__ = (_window$__NEXT_DATA__2 = window.__NEXT_DATA__.props) === null || _window$__NEXT_DATA__2 === void 0 ? void 0 : (_window$__NEXT_DATA__3 = _window$__NEXT_DATA__2.layoutProps) === null || _window$__NEXT_DATA__3 === void 0 ? void 0 : _window$__NEXT_DATA__3.__SSE_JSON) != null ? _window$__NEXT_DATA__ : {};
  return SSEContext();
};
const withSSE = Component => {
  const Context = getOrCreateSSEContext();
  const DataContext = Context.ServerDataContext || Context;
  const WithSSE = props => /*#__PURE__*/React.createElement(DataContext, null, /*#__PURE__*/React.createElement(Component, props));
  return composeDataMethods(Component, {
    async postProcessInitialProps(props) {
      const data = await Context.resolveData();
      props.__SSE_JSON = data;
    }
  })(WithSSE);
};
export default withSSE;